import Cookies from "js-cookie";

export const GetToken = () => {
  var token = Cookies.get("AuthToken");

  if (token) {
    token = Cookies.get("AuthToken");
  } else {
    if (sessionStorage.getItem("analytics_token")) {
      token = sessionStorage.getItem("analytics_token");
    }
  }
  if (token) {
    return "Bearer " + token;
  } else {
    return false;
  }
};
